import { ChevronRight } from "@mui/icons-material";

import {
  ServiceReferralCardContainer,
  ServiceReferralCardCta,
  ServiceReferralCardDescription,
  ServiceReferralCardLink,
  ServiceReferralCardTitle,
} from "./ServiceReferralCard.styled";

export interface ServiceReferralCardProps {
  title: string;
  description: string;
  cta: string;
  href: string;
}

export const ServiceReferralCard = ({
  title,
  description,
  cta,
  href,
}: ServiceReferralCardProps) => {
  return (
    <ServiceReferralCardLink href={href}>
      <ServiceReferralCardContainer className="service-referral-card__container">
        <ServiceReferralCardTitle>{title}</ServiceReferralCardTitle>
        <ServiceReferralCardDescription>
          {description}
        </ServiceReferralCardDescription>
        <ServiceReferralCardCta className="service-referral-card__cta">
          {cta}
          <ChevronRight fontSize="small" />
        </ServiceReferralCardCta>
      </ServiceReferralCardContainer>
    </ServiceReferralCardLink>
  );
};
